import { MouseEventHandler } from "react"
import styles from "./QrButton.module.css"

interface qrButtonProps {
    onClick: MouseEventHandler<HTMLButtonElement> | undefined
}

export default function QrButton({onClick}: qrButtonProps) {
    return(
        <button onClick={onClick} className={ styles.btn }>
            <img className={ styles.im } src="/buttons/qr.png" alt="qr code" />
        </button>
    )
}